import type { PaymentRedirectProps } from '../../models/membership/paymentRedirectProps';
import { requests } from '../httpClient';

export const Payment = {
    getPaymentRedirectAsync: (paymentRedirectProps: PaymentRedirectProps) =>
        requests.get(`Payment/Redirect?SuccessUrl=${paymentRedirectProps.successUrl}&CancelUrl=${paymentRedirectProps.cancelUrl}&PaymentId=${paymentRedirectProps.paymentId}`),
    getPaymentByPaymentIdAsync: (id: string) => requests.get(`Payment/${id}`),
    getPaymentsAsync: () => requests.get(`Payment`),
    getSelfServiceAsync: () => requests.get(`Payment/SelfService`)
};
